import React, { useState, useEffect, useRef, useContext, useMemo } from "react";
import Modal from "react-bootstrap/Modal";
import { BiSearch } from "react-icons/bi";
import {
  AiOutlineUser,
  AiOutlineShoppingCart,
  AiFillInstagram,
} from "react-icons/ai";
import { FiPhone } from "react-icons/fi";
import { BiChevronLeft, BiCurrentLocation } from "react-icons/bi";
import { IoMdClose } from "react-icons/io";
import { FaTelegramPlane } from "react-icons/fa";
import { BsWhatsapp } from "react-icons/bs";
import SearchDropSwiper from "./SearchDropSwiper";
import Container from "../../LogIn/Container.jsx";
import "./header.css";

import { NavLink } from "react-router-dom";
import WithAuthenticationContext from "context/Authentication/AuthenticationContext.ts";
import CardItemContext from "context/CardItem/CardItemContext";
import WebInfoContext from "context/WebInfo/WebInfoContext.ts";

import Basket from "./Basket";
import useAxios from "services/useAxios.tsx";
import { debounce } from "lodash";
import {
  navItems as navItemsConfig,
  socialLinks,
} from "../../../constants/navigation.js";
import { buildCategoryMenuColumns } from "../../../utils/categoryMenu.js";

import logo from "../../../assets/images/logo/ChatGPT Image Nov 17, 2025, 04_11_35 PM.png";
import { CircleLoading } from "react-loadingg";

const Header = ({ active, back }) => {
  const { execute: searchApi } = useAxios("api3/search");
  const { isLogged } = useContext(WithAuthenticationContext);
  const { setShowOffcanvas, itemCount } = useContext(CardItemContext);
  const { categorys, searchQuery, setSearchQuery } = useContext(WebInfoContext);
  const categoryColumns = useMemo(
    () => buildCategoryMenuColumns(categorys),
    [categorys]
  );

  const navigationItems = useMemo(
    () =>
      navItemsConfig.map((item) =>
        item.id === "store" ? { ...item, columns: categoryColumns } : item
      ),
    [categoryColumns]
  );


  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const [loginShow, setLoginShow] = useState(false);
  const [loading, setLoading] = useState(false);
  const [products, setProducts] = useState([]);
  const [categories, setCategories] = useState([]);
  const [articles, setArticles] = useState([]);

  const callApiSearch = async (query) => {
    let data = {};
    data.title = query;
    data.page = 1;
    data.count = 6;

    // Make your API call using the search query
    if (query !== "") {
      await searchApi(data).then((res) => {
        setProducts(res.products.slice(0, 10));
        setCategories(res.hashtags.slice(0, 10));
        setArticles(res.post.slice(0, 10));
      });
    }
    setLoading(false);

    // Replace this console.log with your actual API call
  };
  const searchDebounce = useRef(
    debounce((text) => {
      callApiSearch(text);
    }, 2000)
  );
  useEffect(() => {
    callApiSearch("");
  }, [callApiSearch]);

  function handleOutsideClick(event) {
    const digiSearchDrop = document.querySelector(".digi_search-drop");
    if (digiSearchDrop && !digiSearchDrop.contains(event.target)) active(false);
  }
  // console.log("categoriesList", back, loading);
  const renderSocialIcon = (iconId) => {
    switch (iconId) {
      case "instagram":
        return <AiFillInstagram />;
      case "whatsapp":
        return <BsWhatsapp />;
      case "telegram":
        return <FaTelegramPlane />;
      default:
        return null;
    }
  };

  const handleNavAction = (item) => {
    if (item.path) {
      return (
        <NavLink
          key={item.id}
          to={item.path}
          className="digi_nav-link text-decoration-none"
        >
          {item.label}
        </NavLink>
      );
    }
    if (item.action === "scroll-footer") {
      return (
        <button
          key={item.id}
          className="digi_nav-link text-decoration-none bg-transparent border-0"
          onClick={() =>
            document
              .getElementById("footer-container")
              ?.scrollIntoView({ behavior: "smooth", block: "nearest" })
          }
        >
          {item.label}
        </button>
      );
    }
    return null;
  };

  const renderNavItem = (item) => {
    if (item.type === "mega") {
      return (
        <li key={item.id} className="nav-item has-mega">
          <span className="nav-link">{item.label}</span>
          <div className="mega-menu rounded-4 shadow">
            {(item.columns ?? []).map((column) => (
              <div className="mega-column" key={column.id}>
                <span className="mega-title">{column.title}</span>
                <ul>
                  {column.links.map((link) => (
                    <li key={link.path}>
                      <NavLink
                        to={link.path}
                        className="mega-link"
                        onClick={() => active(false)}
                      >
                        {link.label}
                      </NavLink>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </li>
      );
    }
    if (item.type === "dropdown") {
      return (
        <li key={item.id} className="nav-item has-dropdown">
          <span className="nav-link">{item.label}</span>
          <div className="dropdown-menu shadow rounded-3">
            {item.links.map((link) => (
              <NavLink
                key={link.id}
                to={link.path}
                className="dropdown-link"
                onClick={() => active(false)}
              >
                {link.label}
              </NavLink>
            ))}
          </div>
        </li>
      );
    }
    return (
      <li key={item.id} className="nav-item">
        {handleNavAction(item)}
      </li>
    );
  };

  return (
    <header className="digi_header px-3" onClick={handleOutsideClick}>
      <div className="header_box mb-3">
        <div className="topbar col-12 d-flex align-items-center justify-content-between mb-3">
          <div className="topbar-contact d-flex align-items-center gap-3">
            <span className="d-flex align-items-center text-muted">
              <BiCurrentLocation className="ms-1" />
              تهران، بلوار دامپزشک
            </span>
            <a href="tel:02112345678" className="text-muted text-decoration-none">
              ۰۲۱-۱۲۳۴۵۶۷۸
            </a>
            <a href="tel:09121234567" className="text-muted text-decoration-none">
              ۰۹۱۲۱۲۳۴۵۶۷
            </a>
          </div>
          <div className="topbar-links d-flex align-items-center gap-3">
            <div className="social-icons d-flex align-items-center gap-2">
              {socialLinks.map((link) => (
                <a
                  key={link.id}
                  href={link.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="social-icon"
                >
                  {renderSocialIcon(link.icon)}
                </a>
              ))}
            </div>
            <button
              className="topbar-link link-button"
              onClick={() => (window.location.href = "/all-pages")}
            >
              نحوه سفارش
            </button>
            <button
              className="topbar-link link-button"
              onClick={() =>
                document
                  .getElementById("footer-container")
                  ?.scrollIntoView({ behavior: "smooth", block: "nearest" })
              }
            >
              تماس با ما
            </button>
          </div>
        </div>
        <div className="header-main row align-items-center gx-4">
          <div className="col-lg-3 col-12 d-flex align-items-center mb-3 mb-lg-0">
            <NavLink
              to={"/"}
              className="brand-link text-decoration-none text-dark d-flex align-items-center"
            >
              <img src={logo} className="brand-logo" alt="Logo" />
              <div className="d-flex flex-column me-2">
                <span className="fw-bold">پت‌شاپ + بیمارستان دامپزشکی</span>
                <small className="text-muted">پت مدیک</small>
              </div>
            </NavLink>
          </div>
          <div className="digi_Serachbox align-items-center col-lg-5 col-12">
            <div
              className="digi_search d-flex align-items-center"
              onClick={() => active(true)}
            >
              <BiSearch color="#9e9fb1" size={20} className="search-icon" />
              <input
                type="search"
                placeholder="جستجو"
                className="digi_search-input fs-11"
                onChange={(e) => {
                  setLoading(true);
                  searchDebounce.current(e.target.value);
                  setSearchQuery(e.target.value);
                }}
              />
            </div>
            {back === true && (
              <div className="digi_search-drop" style={{ minHeight: 50 }}>
                {loading ? (
                  <div className="">
                    <CircleLoading />
                  </div>
                ) : (
                  <>
                    {searchQuery?.length !== 0 &&
                      (categories.length !== 0 ? (
                        <div>
                          <div style={{ fontSize: "15px", marginBottom: "5px" }}>
                            دسته بندی ها:
                          </div>
                          <SearchDropSwiper
                            active={active}
                            data={categories}
                            type={"category"}
                            searchQuery={searchQuery}
                          />
                        </div>
                      ) : (
                        <></>
                      ))}
                    {searchQuery?.length !== 0 && (
                      <>
                        <hr />
                        {products.length !== 0 ? (
                          <div>
                            <div
                              style={{ fontSize: "15px", marginBottom: "5px" }}
                            >
                              محصولات:
                            </div>
                            <SearchDropSwiper
                              active={active}
                              data={products}
                              type={"product"}
                              searchQuery={searchQuery}
                            />
                          </div>
                        ) : (
                          <div
                            style={{
                              justifyContent: "center",
                              display: "flex",
                              fontSize: "16px",
                            }}
                          >
                            محصولی با این مشخصات یافت نشد
                          </div>
                        )}
                      </>
                    )}
                    {searchQuery?.length !== 0 && (
                      <>
                        <hr />
                        {articles.length !== 0 ? (
                          <div>
                            <div
                              style={{ fontSize: "15px", marginBottom: "5px" }}
                            >
                              مقالات:
                            </div>
                            <SearchDropSwiper
                              active={active}
                              data={articles}
                              type={"article"}
                              searchQuery={searchQuery}
                            />
                          </div>
                        ) : (
                          <></>
                        )}
                      </>
                    )}
                  </>
                )}
              </div>
            )}
          </div>
          <div className="digi_login d-flex align-items-center col-lg-4 col-12 justify-content-end gap-3">
            <div className="support-box text-end d-none d-lg-block">
              <span className="support-label d-block">پشتیبانی ۲۴ ساعته</span>
              <a href="tel:02112345678" className="support-phone">
                ۰۲۱-۱۲۳۴۵۶۷۸
              </a>
            </div>
            <NavLink
              to="/appointment-booking"
              className="appointment-btn text-decoration-none"
            >
              رزرو نوبت آنلاین
            </NavLink>
            {isLogged === false ? (
              <button
                className="digi_login-box pointer bg-white border-0"
                onClick={() => {
                  setLoginShow(true);
                }}
              >
                <AiOutlineUser
                  size={24}
                  color="#3f4064"
                  className="me-2 cursor-pointer"
                />
              </button>
            ) : (
              <button
                className="digi_login-box p-2 mr-l-8 pointer bg-transparent border-0 d-flex align-items-center"
                onClick={() => {
                  document
                    .getElementById("footer-container")
                    .scrollIntoView({ behavior: "smooth", block: "nearest" });
                }}
              >
                <span className="pe-2 font-12-400 text-nowrap">تماس با ما</span>
                <FiPhone className="wh-14" />
              </button>
            )}
            <div className="digi_basket ps-2 pointer position-relative">
              <AiOutlineShoppingCart
                size={24}
                className="mx-1 "
                onClick={(e) => setShowOffcanvas((prev) => !prev)}
              />
              {itemCount !== 0 && (
                <div
                  className="d-flex p-2 ms-2  align-items-center justify-content-center text-light rounded-pill position-absolute"
                  style={{
                    backgroundColor: "tomato",
                    width: 14,
                    height: 14,
                    fontSize: 12,
                    top: -3,
                    right: -6,
                  }}
                >
                  {itemCount}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
      <nav className="main-navigation">
        <ul className="nav-list">
          {navigationItems.map((item) => renderNavItem(item))}
        </ul>
      </nav>
      <div>
        <Modal show={show} onHide={handleClose} animation={false}>
          <Modal.Body>
            <div className="modal_citys">
              <div className="modal_city-choose mb-4">
                <span>انتخاب شهر</span>
                <IoMdClose
                  size={25}
                  onClick={handleClose}
                  className="city_chosse-icon"
                />
              </div>
              <div className="modal_city-list">
                <div className="modal_location mb-4">
                  <BiCurrentLocation size={25} className="ms-2" />
                  <span>مکان یابی خودکار</span>
                </div>
                <div className="modal_city mb-4">
                  <span>آذربایجان شرقی</span>
                  <BiChevronLeft size={20} />
                </div>
                <div className="modal_city mb-4">
                  <span>آذربایجان شرقی</span>
                  <BiChevronLeft size={20} />
                </div>
                <div className="modal_city mb-4">
                  <span>آذربایجان شرقی</span>
                  <BiChevronLeft size={20} />
                </div>
                <div className="modal_city mb-4">
                  <span>آذربایجان شرقی</span>
                  <BiChevronLeft size={20} />
                </div>
              </div>
            </div>
          </Modal.Body>
        </Modal>
      </div>
      <Container loginShow={loginShow} setLoginShow={setLoginShow} />
      <Basket />
    </header>
  );
};

export default Header;
